import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-block',
  templateUrl: './empty-block.component.html',
  styleUrls: ['./empty-block.component.scss']
})
export class EmptyBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
